export const DATE_FORMAT = 'MM/dd/yyyy';
export const LONG_DATE_FORMAT = "dd MMMM yyyy";
export const TIME_FORMAT = 'HH:mm';
export const DATE_TIME_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT}`;